
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-library",
      function () {
        return require("private-next-pages/video-library/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-library"])
      });
    }
  